import { Endpoint } from '../endpoint';
import { ProposalTemplateFolderId, ProposalTemplateFolderResponse } from '@business/entities/proposal';
import { LibraryFolderStructureResponse } from '@business/entities/library';

export function fetchFolders(parentId?: ProposalTemplateFolderId) {
  return Endpoint.get<ProposalTemplateFolderResponse[]>(`@gc/proposal-template-folder`, { params: { parentId: parentId || '0' } });
}

export function fetchFolder(id: ProposalTemplateFolderId) {
  return Endpoint.get<ProposalTemplateFolderResponse>(`@gc/proposal-template-folder/folder/${id}`);
}

export function createFolder(data: Partial<ProposalTemplateFolderResponse>) {
  return Endpoint.post<ProposalTemplateFolderResponse>(`@gc/proposal-template-folder`, { data });
}

export function updateFolder(id: ProposalTemplateFolderId, data: Partial<ProposalTemplateFolderResponse>) {
  return Endpoint.patch<ProposalTemplateFolderResponse>(`@gc/proposal-template-folder/${id}`, { data });
}

export function deleteFolder(id: ProposalTemplateFolderId) {
  return Endpoint.delete<void>(`@gc/proposal-template-folder/${id}`);
}

export function folderStructure(folderId: ProposalTemplateFolderId) {
  return Endpoint.get<LibraryFolderStructureResponse>(`@gc/proposal-template-folder/folder-structure`, { params: { folderId } });
}
